import React, { useEffect } from 'react';


function EditPrivate({ invitation }) {

    useEffect(() => {
      }, []);

  return (
    <div>editPrivate</div>
  )
}

export default EditPrivate